import React from "react";
import "./AyanavaramCommunity.css";

const priestImagePath = "/assets/images/priest/h-priest/";

const communityMembers = [
  {
    name: "P Thamathiruthuvam Irudayam",
    role: "Rector / Parish Priest / Correspondent / Local Delegate for Salesian Cooperators",
    image: `${priestImagePath}thamathiruthuvam-sdb.png`,
  },
  {
    name: "P Williams Paulraj",
    role: "Vice-Rector / Principal / Assistant Parish Priest",
    image: `${priestImagePath}williams-Paulraj-sdb.png`,
  },
  {
    name: "P Jagadeesh Arulappan",
    role: "Administrator / Assistant Parish Priest",
    image: `${priestImagePath}jagadeesh.png`,
  },
  {
    name: "P Adukanil Mathew",
    role: "AM - Confessor",
    image: "",
  },
  {
    name: "P Amalraj Aaservatham",
    role: "In Charge: Parish Youth / Youth Services Coordinator / Assistant Parish Priest / Liturgical Animator",
    image: `${priestImagePath}amalraj-sdb.png`,
  },
  {
    name: "P Raymond Joseph (SLK)",
    role: "Assistant Parish Priest",
    image: `${priestImagePath}reymond-sdb.png`,
  },
];

const ministryItems = [
  "Parish Ministry: Don Bosco Shrine",
  "Pious Associations",
  "Academic Education: DB Mat. Hr. Sec. School",
  "Social Ministry: Evening Study Centre",
  "Youth Group",
  "Salesian Family: Salesian Cooperators & ADMA",
];

const AyanavaramCommunity = () => {
  return (
    <main className="ayanavaram-community-page">
      <section className="container community-section">
        <div className="community-profile-grid">
          <article className="community-profile-panel">
            <h2>Community Profile</h2>
            <div className="community-facts">
              <div>
                <span>Established</span>
                <strong>1966</strong>
              </div>
              <div>
                <span>Status</span>
                <strong>Canonically Erected in 2003</strong>
              </div>
              <div>
                <span>Diocese</span>
                <strong>MADRAS-MYLAPORE</strong>
              </div>
            </div>
          </article>

          <article className="community-contact-panel">
            <h2>Address</h2>
            <address>
              <strong>Don Bosco Shrine</strong>
              <br />
              86, P. E. Koil West Mada Street
              <br />
              Ayanavaram, Chennai - 600 023.
            </address>
            <a href="mailto:rector.dbayanavaram@sdbchennai.org">
              <i className="fa fa-envelope"></i>
              rector.dbayanavaram@sdbchennai.org
            </a>
          </article>
        </div>

        <article className="community-ministry-panel">
          <div>
            <span className="community-kicker">Ministry</span>
            <h2>Mission And Services</h2>
          </div>
          <div className="community-ministry-list">
            {ministryItems.map((item) => (
              <span key={item}>{item}</span>
            ))}
          </div>
        </article>

        <section className="community-members">
          <div className="community-section-title">
            <span className="community-kicker">Community</span>
            <h2>Salesian Community Members</h2>
          </div>

          <div className="community-member-grid">
            {communityMembers.map((member) => (
              <article className="community-member-card" key={member.name}>
                {member.image ? (
                  <img
                    src={member.image}
                    alt={member.name}
                    onError={(event) => {
                      event.currentTarget.style.display = "none";
                      event.currentTarget.nextSibling.style.display = "flex";
                    }}
                  />
                ) : null}
                <div
                  className="community-member-fallback"
                  style={{ display: member.image ? "none" : "flex" }}
                >
                  {member.name
                    .split(" ")
                    .filter(Boolean)
                    .slice(0, 2)
                    .map((word) => word[0])
                    .join("")}
                </div>
                <div className="community-member-body">
                  <h3>{member.name}</h3>
                  <p>{member.role}</p>
                </div>
              </article>
            ))}
          </div>
        </section>
      </section>
    </main>
  );
};

export default AyanavaramCommunity;
